// import React, { useState } from 'react'
import Header from '../components/Header';
import Signup from '../components/Signup';
import { hasRequiredOAuthParams } from '../lib/helpers';

const SignupPage = () => {
  // Signup is only valid inside an OAuth flow — we need the client + redirect
  // params to resolve the application (and its registered verify URL). Without
  // them there's no app context, so show a "not available" notice instead.
  if (!hasRequiredOAuthParams()) {
    return (
      <div className="max-w-sm flex flex-col items-center justify-center min-h-screen mx-auto text-center">
        <Header
          heading="Signup not available"
          paragraph="Please start signing up from the app you were using."
          hideAuthMode
        />
      </div>
    );
  }

  return (
    <div className="grid lg:grid-cols-2 lg:gap-6 w-full justify-center">
      <div className="hidden lg:block h-full max-h-screen py-8 sticky top-0">
        <div
          className="h-full w-full rounded-md overflow-hidden bg-cover flex flex-col justify-end bg-center"
          style={{ backgroundImage: 'url(/img/signup.jpg)' }}
        ></div>
      </div>
      <div className="max-w-sm flex flex-col items-start justify-center min-h-screen mx-auto">
        <Header
          heading="Create an account"
          paragraph="Let’s get started. Fill in the details below to create your account."
        />

        <Signup />
      </div>
    </div>
  );
};

export default SignupPage;
